import { PAGE_KEY_ACCESSIBILITY_POLICY } from "@constants";
import { createLazyTemplateItem } from "../utils";
import { mergeTemplateItems } from "./utils";

const TEMPLATE_KEY = "common/AccessibilityPolicyTemplate";

const AccessibilityTemplate = props => {
  const { markdown } = props.accessibility;

  const defaultTemplate = [
    {
      __comment__: "accessibility-policy block",
      component: "core/MarkdownRenderer",
      props: { markdown }
    },
    ...props.widgets
  ];

  return mergeTemplateItems(defaultTemplate, props.templates).map(
    createLazyTemplateItem
  );
};

AccessibilityTemplate.mapValueToProps = value => ({
  accessibility: value.accessibilityPolicy
});

AccessibilityTemplate.mapValueToTemplateProps = {
  pageKey: PAGE_KEY_ACCESSIBILITY_POLICY,
  templateKey: TEMPLATE_KEY
};

export default AccessibilityTemplate;
